import { render, staticRenderFns } from "./hamburger-menu.vue?vue&type=template&id=2027d3cc&"
import script from "./hamburger-menu.vue?vue&type=script&lang=js&"
export * from "./hamburger-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports